import { gql, useMutation } from '@apollo/client';

export const SIGNATURE_REQUEST_FIELDS = gql`
  fragment SignatureRequestFields on SignatureRequest {
    id
    createdAt
    updatedAt
    signee1 {
      id
      name
      email
    }
    signee2 {
      id
      name
      email
    }
    hasSigned1
    hasSigned2
    signature1
    signature2
    includeSubcontractors
    includeToms
  }
`;

const CREATE_SIGNATURE_REQUEST = gql`
  ${SIGNATURE_REQUEST_FIELDS}
  mutation CreateSignatureRequest(
    $contractId: String!
    $signer: [SignerInput!]!
    $includeSubcontractors: Boolean
    $includeToms: Boolean
    $signature1Position: JSON
    $signature2Position: JSON
  ) {
    createSignatureRequest(
      contractId: $contractId
      signer: $signer
      includeSubcontractors: $includeSubcontractors
      includeToms: $includeToms
      signature1Position: $signature1Position
      signature2Position: $signature2Position
    ) {
      ...SignatureRequestFields
    }
  }
`;

export interface SignaturePosition {
  page: number;
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface CreateSignatureRequestInput {
  contractId: string;
  signer: SignerInput[];
  includeSubcontractors?: boolean;
  includeToms?: boolean;
  signature1Position?: SignaturePosition;
  signature2Position?: SignaturePosition;
}

export interface SignerInput {
  email: string;
  first_name: string;
  last_name: string;
}

export interface ISignatureRequest {
  id: string;
  createdAt: string;
  updatedAt: string;
  signee1: ISigner;
  signee2: ISigner;
  hasSigned1: boolean;
  hasSigned2: boolean;
  signature1?: string;
  signature2?: string;
  includeSubcontractors: boolean;
  includeToms: boolean;
}

export interface ISigner {
  id: string;
  name: string;
  email: string;
}

export interface CreateSignatureRequestResult {
  createSignatureRequest: ISignatureRequest;
}

export function useCreateSignatureRequestMutation() {
  return useMutation<CreateSignatureRequestResult, CreateSignatureRequestInput>(CREATE_SIGNATURE_REQUEST, {
    refetchQueries: ['GetCompany', 'GetUserValues'],
  });
}
